import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
  ],
  selector: 'ui-losses-info-center-card',
  template: `
    <div class="bg-white shadow-md px-4 py-3 rounded-lg h-full" *transloco="let t">
      <div class="grid grid-cols-12 w-full">
        <div class="col-span-4 flex items-center"><p>{{ t('LOSSES.CARD.CENTER_LOSSES') }}</p></div>
        <div class="col-span-8 grid grid-cols-12 font-medium">
          <div class="col-span-4 flex items-center justify-end"><p><span class="uppercase text-neutral-7">{{ t('LOSSES.CARD.ENERGY_CT') }}:</span> {{ energy() }}</p></div>
          <div class="col-span-4 flex items-center justify-end"><p><span class="uppercase text-neutral-7">{{ t('LOSSES.CARD.CONSUMPTION_CLIENT') }}:</span>  {{ consumption() }}</p></div>
          <div class="col-span-4 flex items-center justify-end"><p><span class="uppercase text-neutral-7">{{ t('LOSSES.LABEL') }}:</span> {{ losses() }}</p> <span class="text-amber-700 bg-amber-100 rounded-full p-1 font-medium text-sm ms-2">{{ lossesPercentage() }}</span></div>
        </div>
      </div>
    </div>
  `,
})
export class LossesInfoCenterCardComponent {
  energy= input<string>();
  consumption= input<string>()
  losses= input<string>();
  lossesPercentage= input<string>();
}
